module.exports = "https://r.zoocdn.com/_next/static/other/browserconfig-984c73468b8ad06e2fa0d6eb067e975d.xml";